// CTA de fin d'article

import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowRight, Sparkles } from "lucide-react";

const ArticleCTA = () => {
  return (
    <section className="py-16 bg-[#0F172A]">
      <div className="container mx-auto px-4">
        <div className="max-w-2xl mx-auto">
          <div className="rounded-2xl p-[1px] bg-gradient-to-b from-[#F59E0B]/30 to-transparent">
            <div className="rounded-2xl bg-[#1E293B]/80 backdrop-blur-sm p-8 md:p-12 text-center">
              {/* Icone */}
              <div className="inline-flex items-center justify-center w-14 h-14 rounded-[12px] bg-[#131318] border border-white/[0.06] mb-6">
                <Sparkles className="w-6 h-6 text-white/50" strokeWidth={2.5} />
              </div>

              {/* Titre */}
              <h2 className="text-2xl md:text-3xl font-bold text-white mb-4">
                Pret a optimiser votre rentabilite ?
              </h2>

              {/* Description */}
              <p className="text-white/60 mb-8 max-w-md mx-auto">
                Essayez B8ild gratuitement pendant 14 jours et reprenez le controle de vos chantiers. 100% de visibilité sur vos marges.
              </p>

              {/* Bouton */}
              <Button
                size="lg"
                className="h-12 px-8 bg-[#F59E0B] hover:bg-[#FBBF24] text-[#0A0A0F] font-semibold gap-2 rounded-xl shadow-[0_4px_20px_rgba(245,158,11,0.3)] hover:shadow-[0_6px_30px_rgba(245,158,11,0.4)] transition-all duration-200"
                asChild
              >
                <Link to="/auth?mode=signup">
                  Essayer gratuitement 14 jours
                  <ArrowRight className="w-4 h-4" />
                </Link>
              </Button>

              {/* Reassurance */}
              <p className="mt-4 text-xs text-white/40">
                Sans engagement - Configuration en 5 minutes
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ArticleCTA;
